module.exports = __webpack_public_path__ + "static/assets/0543e05716fd737ba9be869436343db6.png";